// React Imports 
import { useState } from 'react';

// Component Imports
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';

export default function AlertDialog({
    dialogOpen,
    dialogTitle,
    dialogText,
    onConfirm,
    onCancel,
    confirmButtonText,
    confirmButtonIcon = null,
    cancelButtonIcon = null,
    cancelButtonText,
    isForm,
    formDetails,
}) {
    const [inputValue, setInputValue] = useState(formDetails?.value || "");

    const handleConfirm = () => {
        onConfirm(inputValue || true)
        setInputValue("")
    }

    const handleCancel = () => {
        onCancel(false)
        setInputValue("")
    }
    return (
        <>
            <Dialog
                open={dialogOpen}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiDialog-paper": {
                        width: "400px",
                        maxWidth: "400px",
                        padding: "24px",
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {dialogTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" sx={{ marginBottom: "8px" }}>
                        {dialogText}
                    </DialogContentText>
                    {isForm && <TextField
                        autoFocus
                        required
                        margin="dense"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevents form submission (if any)
                                handleConfirm(); // Calls the confirm action
                            }
                        }}
                        value={inputValue}
                        id={formDetails?.name}
                        name={formDetails?.name}
                        label={formDetails?.label}
                        type={formDetails?.type || "text"}
                        fullWidth
                        variant={formDetails?.variant || "outlined"}
                    />}
                </DialogContent>
                <DialogActions>
                    {cancelButtonText && (
                        <AivagamButton
                            buttonText={
                                <div style={{ display: 'flex', gap: '0.5em', alignItems: 'center', justifyContent: 'center' }}>
                                    {cancelButtonIcon}{cancelButtonText}
                                </div>
                            }
                            onClick={handleCancel}
                            classStyles={{
                                width: "120px",
                                height: "40px",
                                borderRadius: "20px",
                                padding: "8px 16px",
                                color: '#1450a0',
                                borderColor: '#1450a0',
                                backgroundColor: '#ffffff',
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"
                            }}
                        />
                    )}
                    <AivagamButton
                        buttonText={
                            <div style={{ display: 'flex', gap: '0.5em', alignItems: 'center', justifyContent: 'center' }}>
                                {confirmButtonIcon}{confirmButtonText}
                            </div>
                        }
                        onClick={handleConfirm}
                        classStyles={{
                            width: "120px",
                            height: "40px",
                            borderRadius: "20px",
                            padding: "8px 16px",
                            color: '#ffffff',
                            borderColor: '#ffffff',
                            backgroundColor: '#1450a0',
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)"
                        }}
                    />
                </DialogActions>
            </Dialog>
        </>
    )
}